import {
  Badge,
  Icon,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import clsx from "clsx";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import useConfig from "../../hooks/useConfig";
import { useStore } from "../../hooks/useStore";
import CustomPopover from "../common/CustomPopover";
import { useStyles } from "./MenuOptionStyles";

type MenuOptionProps = {
  iconUrl: string,
  text: string,
  route: string,
  open: boolean,
  keys: string,
  modalOpen?: () => void,
  showBadge?: boolean,
};
const MenuOption = ({
  iconUrl,
  text,
  route,
  open,
  keys,
  modalOpen,
  showBadge,
}: MenuOptionProps) => {
  const [openCustomPopover, setOpenCustomPopover] = useState(false);
  const { pendingRequestStore, tabStore } = useStore();
  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const { openDialogOnHold } = useConfig();

  const handlePopoverOpen = () => {
    setOpenCustomPopover(true);
  };

  const handlePopoverClose = () => {
    setOpenCustomPopover(false);
  };

  const redirectTo = (route: any) => {
    if (tabStore.tabSelectIndex !== "-1") {
      openDialogOnHold({ route });
    } else {
      history.push(route);
    }
  };
  return (
    <>
      <ListItem
        button
        onClick={() => (modalOpen ? modalOpen() : redirectTo(route))}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        className={clsx(classes.item, {
          [classes.itemSm]: matches,
        })}
      >
        {showBadge ? (
          <Badge
            badgeContent={pendingRequestStore.listPendingRequest.length}
            color="error"
            max={999}
            overlap='rectangular'
          >
            <ListItemIcon className={classes.listItemIcon}>
              <Icon className={classes.icon}>
                <img src={iconUrl} alt={text} className={classes.icon} />
              </Icon>
            </ListItemIcon>
          </Badge>
        ) : (
          <ListItemIcon className={classes.listItemIcon}>
            <Icon className={classes.icon}>
              <img src={iconUrl} alt={text} className={classes.icon} />
            </Icon>
          </ListItemIcon>
        )}
        <ListItemText
          primary={
            <Typography variant="subtitle1" gutterBottom>
              {text}
            </Typography>
          }
          className={clsx(
            {},
            {
              [classes.itemOpen]: open,
              [classes.itemClose]: !open,
            }
          )}
        />
        <CustomPopover open={openCustomPopover} title={keys} />
      </ListItem>
    </>
  );
};
export default MenuOption;
